import { useRecoilTask } from 'recoil-toolkit';

import { rolesState } from './atoms';
import { getRolesTask } from './tasks';

export const useRoles = () => useRecoilTask(getRolesTask, [], {
  dataSelector: rolesState,
  errorStack: true,
});
